import PaymentIcon from "../../assets/images/vectors/SideBarIcons/PaymentIcon";

export const allProtectedRouteList = {
  1: [
    "/profile",
    "/oem",
    "/oem/add",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",
    "/site/license",
    "/device/add",
    "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    "/device",
    "/devicelog",
    "/orderlist",
    "/order/add",
    "/orderedit",
    "/orderinfo/edit",
    "/orderinfo/info",
    "/orderitemlist",
    "/orderitem/add/",
    "/payment",
    "/payment/info",
    "/order",
    "/invoice",
    "/invoice/add",
    "/invoice/info",
    "/license",
    "/license/add",
    "/license/edit",
    "/license/info",
    "/licensecode",
    "/licensecode/add",
    "/licensecode/edit",
    "/licensecode/info",
    "/licenseoptionlist",
    "/licenseoption/add",
    "/licenseoption/info",
    "/licenseoption/edit",
    "/licenseoption",
    "/oem/edit",
    "/oem/info",
    "/oeminfo",
    "/oeminfo/add",
    "/oeminfo/edit",
    "/oeminfo/info",
    "/addDeviceByList",
    "/addDeviceByCount",
    "/orderitem/edit",
    "/orderitem/info",
    "/sip",
    "/sip/add",
    "/sip/edit",
    "/sip/info",
    "/sip/addSipByList",
    "/sip/addSipByCount",
    "/proxyserver",
    "/proxyserver/add",
    "/proxyserver/edit",
    "/proxyserver/info",
    "/production",
    "/production/add",
    "/production/edit",
    "/production/info",
    // "/productionitem/add",
    "/productionitem/info",
    // "/addproductionbycount/info",
    // "/addproductionbylist/info",
    "/prepurchased-license",
    "/prepurchased-license/add",
    "/prepurchased-license/edit",
    "/prepurchased-license/info",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
    "/hardware",
    "/hardware/add",
    "/hardware/edit",
    "/hardware/info",
    "/plate",
    "/plate/add",
    "/plate/edit",
    "/plate/info",
    "/payment",
  ],
  2: [
    "/profile",
    "/oem",
    "/oem/add",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",
    "/device/add",
    "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    "/device",
    "/devicelog",
    "/orderlist",
    "/order/add",
    "/orderedit",
    "/orderinfo/edit",
    "/orderinfo/info",
    "/orderitemlist",
    "/orderitem/add/",
    "orderiteminfo",
    "/order",
    "/invoice",
    "/invoice/add",
    "/invoice/info",
    "/license",
    "/license/add",
    "/license/edit",
    "/license/info",
    "/licensecode",
    "/licensecode/add",
    "/licensecode/edit",
    "/licensecode/info",
    "/licenseoptionlist",
    "/licenseoption/add",
    "/licenseoption/info",
    "/licenseoption/edit",
    "/licenseoption",
    "/oeminfo",
    "/oeminfo/add",
    "/oem/edit",
    "/oem/info",
    "/oeminfo/edit",
    "/oeminfo/info",
    "/addDeviceByList",
    "/addDeviceByCount",
    "/orderitem/edit",
    "/orderitem/info",
    "/sip",
    "/sip/add",
    "/sip/edit",
    "/sip/info",
    "/sip/addSipByList",
    "/sip/addSipByCount",
    "/proxyserver",
    "/proxyserver/add",
    "/proxyserver/edit",
    "/proxyserver/info",
    "/production",
    "/production/add",
    "/production/edit",
    "/production/info",
    // "/productionitem/add",
    "/productionitem/info",
    // "/addproductionbycount/info",
    // "/addproductionbylist/info",
    "/prepurchased-license",
    "/prepurchased-license/add",
    "/prepurchased-license/edit",
    "/prepurchased-license/info",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
    "/hardware",
    "/hardware/add",
    "/hardware/edit",
    "/hardware/info",
    "/plate",
    "/plate/add",
    "/plate/edit",
    "/plate/info",
    "/payment",
  ],
  3: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "/device/add",
    // "/devicelog/info/",
    "/device",
    "/device/info",
    "/payment",
    // "/devicelog",
    // "/order",
    // "/invoice",
    // "/invoice/add",
    // "/invoice/info",
    // "/license",
    // "/license/add",
    // "/license/edit",
    // "/license/info",
    // "/licensecode",
    // "/licensecode/add",
    // "/licensecode/edit",
    // "/licensecode/info",
    // "/sip",
    // "/sip/add",
    // "/sip/edit",
    // "/sip/info",
    // "/sip/addSipByList",
    // "/sip/addSipByCount",
    // "/proxyserver",
    // "/proxyserver/add",
    // "/proxyserver/edit",
    // "/proxyserver/info",
    // "/oeminfo",
    // "/oeminfo/add",
    // "/oeminfo/edit",
    // "/oeminfo/info",
    // "/productionlist",
    // "/production/add",
    // "/production/edit",
    // "/production/info",
    // "/productionitem/add",
    // "/productionitem/info",
    // "/addproductionbycount/info",
    // "/addproductionbylist/info",
    // "/hardwarelist",
    // "/hardware/add",
    // "/hardware/edit",
    // "/hardware/info",
  ],
  4: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/invoice",
    // "/invoice/add",
    // "/invoice/info",
    // "/orderitem/edit",
    // "/orderitem/info",

    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
  ],
  5: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/invoice",
    // "/invoice/add",
    // "/invoice/info",
    // "/orderitem/edit",
    // "/orderitem/info",

    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
  ],
  6: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "/devicelog/info/",
    // "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/invoice",
    // "/invoice/add",
    // "/invoice/info",
    // "/orderitem/edit",
    // "/orderitem/info",
    "/payment",
  ],
  7: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",
    "/device/add",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    "/invoice",
    // "/invoice/add",
    "/invoice/info",
    // "/orderitem/edit",
    // "/orderitem/info",

    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
  ],
  8: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",
    "/device/add",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    "/invoice",
    // "/invoice/add",
    "/invoice/info",
    // "/orderitem/edit",
    // "/orderitem/info",
    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
  ],
  9: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "device/add",
    // "/devicelog/info/",
    // "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    "/invoice",
    // "/invoice/add",
    "/invoice/info",
    // "/orderitem/edit",
    // "/orderitem/info",
    "/payment",
  ],
  10: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/orderitem/edit",
    // "/orderitem/info",
  ],
  11: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/orderitem/edit",
    // "/orderitem/info",
  ],
  12: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/orderitem/edit",
    // "/orderitem/info",
  ],
};
